import _pick from 'lodash/pick';
import _omitBy from 'lodash/omitBy';
import _isUndefined from 'lodash/isUndefined';
import React from 'react';
import { isEditor } from '../../utils/isEditor.js';
import LoanComparisonCalculator from './LoanComparisonCalculator.js';
import { FieldConfig } from './LoanComparison.utils.js';

var _attributes;
var LoanComparisonBlock = {
  Component: function Component(_ref) {
    var attrs = _ref.attrs;
    var defaultValues = _omitBy(_pick(attrs, Object.keys(FieldConfig)), _isUndefined);
    var editorMode = isEditor();
    return /*#__PURE__*/React.createElement(LoanComparisonCalculator, {
      editorMode: editorMode,
      key: isEditor() ? JSON.stringify(defaultValues) : undefined,
      defaultValues: defaultValues
    });
  },
  metadata: {
    $schema: 'https://schemas.wp.org/trunk/block.json',
    version: '1.0',
    name: 'constellation/loan-comparison-calculator',
    title: 'Loan Comparison Calculator',
    description: 'Loan Comparison Calculator',
    icon: 'chart-line',
    keywords: ['Mortgage comparison calculator', 'Mortgage loan comparison calculator', 'Loan comparison calculator'],
    supports: {
      customClassName: false,
      html: false
    },
    attributes: (_attributes = {}, _attributes[FieldConfig.typeOneLoanAmount.name] = {
      type: 'number',
      label: 'Loan 1: Default loan amount',
      default: 300000,
      control: 'number'
    }, _attributes[FieldConfig.typeOneLoanTerm.name] = {
      type: 'string',
      label: 'Loan 1: Default loan program',
      default: FieldConfig.typeOneLoanTerm.options[0].value,
      control: 'select',
      choices: FieldConfig.typeOneLoanTerm.options
    }, _attributes[FieldConfig.typeOneInterestRate.name] = {
      type: 'number',
      label: 'Loan 1: Default interest rate',
      default: 4.176,
      control: 'number'
    }, _attributes[FieldConfig.typeTwoLoanAmount.name] = {
      type: 'number',
      label: 'Loan 2: Default loan amount',
      default: 300000,
      control: 'number'
    }, _attributes[FieldConfig.typeTwoLoanTerm.name] = {
      type: 'string',
      label: 'Loan 2: Default loan program',
      default: FieldConfig.typeTwoLoanTerm.options[0].value,
      control: 'select',
      choices: FieldConfig.typeTwoLoanTerm.options
    }, _attributes[FieldConfig.typeTwoInterestRate.name] = {
      type: 'number',
      label: 'Loan 2: Default interest rate',
      default: 4.176,
      control: 'number'
    }, _attributes[FieldConfig.typeThreeLoanAmount.name] = {
      type: 'number',
      label: 'Loan 3: Default loan amount',
      default: 300000,
      control: 'number'
    }, _attributes[FieldConfig.typeThreeLoanTerm.name] = {
      type: 'string',
      label: 'Loan 3: Default loan program',
      default: FieldConfig.typeThreeLoanTerm.options[0].value,
      control: 'select',
      choices: FieldConfig.typeThreeLoanTerm.options
    }, _attributes[FieldConfig.typeThreeInterestRate.name] = {
      type: 'number',
      label: 'Loan 3: Default interest rate',
      default: 4.176,
      control: 'number'
    }, _attributes)
  }
};
var LoanComparisonBlock$1 = LoanComparisonBlock;

export { LoanComparisonBlock$1 as default };
